import { render, staticRenderFns } from "./formgroupsocialsecurityno.vue?vue&type=template&id=10306f90&"
import script from "./formgroupsocialsecurityno.vue?vue&type=script&lang=js&"
export * from "./formgroupsocialsecurityno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports